export default {
  PERSIAN: `PERSIAN`,
  CUSTOMER_LANGUAGE: `CUSTOMER_LANGUAGE`,
};
